import { Component, OnInit } from '@angular/core';
import { ISave } from '@app-settings/shared/models/i-save.model';
import { SettingsService } from '@app-settings/shared/settings.service';
import { BaseComponent } from '@core/components/base-component';
import { EnumItem } from '@core/models/enum-item.model';
import { BudgetPercentDenominatorEnum } from '@enums/BudgetPercentDenominator';
import { EstimateConfiguration } from '@interfaces/EstimateConfiguration';
import { BudgetPercentDenominatorEnumItems } from '@models/consts/budget-percent-denominator-enum-items.const';
import { TranslateService } from '@ngx-translate/core';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';

@Component({
  templateUrl: './estimate-interface-settings.component.html',
  styleUrls: ['../settings.component.less', './estimate-interface-settings.component.less']
})
export class EstimateInterfaceSettingsComponent extends BaseComponent implements OnInit, ISave {
  public budgetPercentDenominatorValues: EnumItem<BudgetPercentDenominatorEnum>[];
  public currentLang: string = this.translateService.currentLang;
  public estimateConfig: EstimateConfiguration;
  public isLoading = false;
  public selectedClassifications: string[] = [];
  public selectedClassificationResources: string[] = [];
  public showBudgetPercentColumns = true;
  public showCustomLabels = true;
  public showEstimateTable = true;

  public constructor(
    private translateService: TranslateService,
    private estimateSettingsService: EstimateSettingsService,
    private popSettingsService: SettingsService
  ) {
    super();
    this.budgetPercentDenominatorValues = BudgetPercentDenominatorEnumItems;
  }

  public ngOnInit() {
    this.isLoading = true;

    this.subscribe(
      this.estimateSettingsService.getEstimateConfiguration().subscribe(estimateConfig => {
        this.estimateConfig = estimateConfig;
        this.isLoading = false;
      })
    );
  }

  public changed() {
    this.popSettingsService.needsSave();
    this.popSettingsService.onSave(this);
  }

  public async onSave() {
    await this.estimateSettingsService.setEstimateConfiguration(this.estimateConfig);
  }
}
